const PrivacyPolicy = () => {
    return(
    <section className="bg-white py-16 md:py-24 px-4">
      <div className="max-w-4xl mx-auto text-center">

        {/* Title */}
        <h1 className="text-3xl md:text-5xl font-semibold text-[#0c0407] mb-6">
          Политика за приватност
        </h1>

        {/* Subtitle */}
        <p className="text-[#0C0407] text-base md:text-lg mb-6">
          Merakzy ја почитува вашата приватност и е посветен на заштита на вашите лични податоци. Оваа Политика за приватност објаснува како ги собираме, користиме и заштитуваме информациите кога ја користите Merakzy веб платформата, мобилната апликација и поврзаните услуги.
        </p>

        <p className="text-[#0C0407] text-base md:text-lg mb-6">
          Последно ажурирање: декември 2025
        </p>

        <div className="relative bg-white border border-gray-200 rounded-[40px] p-8 shadow-sm transition-all text-left">

            <h2 className="text-xl font-semibold text-[#0c0407] mb-3">Информации што ги собираме</h2>
            <p className="text-[#0C0407] text-base mb-6">
                Merakzy собира само информации неопходни за правилно функционирање на платформата и услугите. 
            </p>

            <p className="text-[#0C0407] text-base">
               Ова може да вклучува:
            </p>
            
            <ul className="text-[#0C0407] text-base list-disc list-inside mb-6">
                <li>Информации за корисничка сметка како емаил адреса</li>
                <li>Податоци за најава што се користат за автентикација</li>
                <li>Основни податоци за користење поврзани со функционалноста на системот</li>
            </ul>
            <p className="text-[#0C0407] text-base mb-6">
                Merakzy не собира чувствителни лични податоци и нема пристап до контакти, фотографии, микрофон, камера или локација.
            </p>

            <h2 className="text-xl font-semibold text-[#0c0407] mb-3">Како ги користиме информациите</h2>
            <p className="text-[#0C0407] text-base">
                Собраните информации ги користиме исклучиво за:
            </p>
            <ul className="text-[#0C0407] text-base list-disc list-inside mb-6">
                <li>Обезбедување и одржување на Merakzy услугата</li>
                <li>Овозможување на најава и пристап до кориснички сметки</li>
                <li>Подобрување на перформансите и корисничкото искуство</li>
                <li>Обезбедување корисничка поддршка по ваше барање</li>
            </ul>
            <p className="text-[#0C0407] text-base mb-6">
                Вашите податоци не се користат за рекламни или маркетинг цели.
            </p>

            <h2 className="text-xl font-semibold text-[#0c0407] mb-3">Споделување на податоци</h2>
            <p className="text-[#0C0407] text-base mb-6">
                Merakzy не продава, не изнајмува и не ги споделува вашите лични податоци со трети страни.
            </p>

            <p className="text-[#0C0407] text-base mb-6">
                Податоците може да бидат обработувани исклучиво од доверливи сервис провајдери, само кога е неопходно за функционирање на услугата.
            </p>

            <h2 className="text-xl font-semibold text-[#0c0407] mb-3">Безбедност на податоците</h2>
            <p className="text-[#0C0407] text-base mb-6">
                Ги задржуваме корисничките податоци само додека сметката е активна или колку што е потребно за обезбедување на услугата. Податоците може да бидат избришани по затворање на корисничката сметка.
            </p>

            <h2 className="text-xl font-semibold text-[#0c0407] mb-3">Приватност на деца</h2>
            <p className="text-[#0C0407] text-base mb-6">
                Merakzy не е наменет за користење од лица помлади од 16 години и свесно не собираме лични податоци од деца.
            </p>

            <h2 className="text-xl font-semibold text-[#0c0407] mb-3">Ваши права</h2>
            <p className="text-[#0C0407] text-base mb-6">
                Имате право да пристапите до вашите податоци, да ги ажурирате или да побарате нивно бришење. Барањата може да ги поднесете преку контакт информациите подолу.
            </p>

            <h2 className="text-xl font-semibold text-[#0c0407] mb-3">Промени на оваа политика</h2>
            <p className="text-[#0C0407] text-base mb-6">
                Оваа Политика за приватност може повремено да биде ажурирана. Сите промени ќе бидат објавени на оваа страница.
            </p>

            <h2 className="text-xl font-semibold text-[#0c0407] mb-3">Контакт</h2>
            <p className="text-[#0C0407] text-base">
                Доколку имате прашања поврзани со оваа Политика за приватност или со начинот на кој ги обработуваме податоците, можете да не контактирате на <a href="mailto:contact@merakzy.com" className="text-blue-600 underline">contact@merakzy.com</a>
            </p>

        </div>
      </div>
    </section>
    )
}

export default PrivacyPolicy; 

